import { useContext, useEffect, useRef, useState } from "react";
import { classNames } from "primereact/utils";
import { Toast } from "primereact/toast";
import { RadioButton } from "primereact/radiobutton";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { toastShow } from "../../../Services/ToastService";
import { MultiSelect } from "primereact/multiselect";
import { Button } from "primereact/button";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import Card from "../../../Components/Card/Card";
import { getRoles } from "../../../API/IT/Roles/RolesRequests";
import { getUsersBasic } from "../../../API/IT/Users/UserRequests";
import { sendNotification } from "../../../../API/Notificaciones/NotificacionesRequest";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";

function NotificacionesScreen() {
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [titulo, setTitulo] = useState("");
  const [contenido, setContenido] = useState("");
  const [areaSelected, setAreaSelected] = useState([]);
  const [areas, setAreas] = useState([]);
  const [tipo, setTipo] = useState(0);
  const [Url, setUrl] = useState("");
  const [version, setVersion] = useState("");
  const [enviarA, setEnviarA] = useState(2);
  const [userSelected, setUserSelected] = useState([]);
  const [users, setUsers] = useState([]);
  const [showErrors, setShowErrors] = useState(false);
  const [dataNotificacion, setDataNotificacion] = useState("");

  const getInfo = async () => {
    const areas = await getRoles();
    const users = await getUsersBasic();
    setAreas(areas);
    setUsers(users);
}

  const verificarCampos = () => {
    if (tipo === 0) {
      if (titulo === "" || enviarA === null) {
        return false;
      }
    }
    if (tipo === 1) {
      if (areaSelected === null || version === "") {
        return false;
      }
    }
    if (tipo === 2) {
      if (titulo === "" || enviarA === null || Url === "") {
        return false;
      }
    }

    if (enviarA === 1) {
      if (areaSelected.length === 0) {
        return false;
      }
    }
    if (enviarA === 2) {
      if (userSelected.length === 0) {
        return false;
      }
    }
    return true;
  };

  const enviarNoticia = async () => {
    setShowErrors(false);
    if (verificarCampos()) {
      let usersSend = "";
      let title = titulo;
      let body = contenido;
      let data = {};

      if (enviarA === 0) {
          usersSend = users.map(user => user.IdUser);
      }
      if (enviarA === 1) {

          usersSend = areaSelected.map(Rol => users.filter(user => user.IdRol === Rol.IdRol).map(user => user.IdUser)).flat();
      }
      if (enviarA === 2) {
          usersSend = userSelected.map(user => user.IdUser);
      }

      if(tipo === 1){
          title = 'Nueva actualización disponible';
          body =  `Se ha publicado la versión ${version}`;
          data = {actualizacion: "true"}
      }
      if(tipo === 2){
          data = {Url: Url}
      }
      if(tipo === 3){
        data = {Data: dataNotificacion}
      }

      const notificacion = {
          title,
          body,
          data,
          usuarios: usersSend,
          Tipo: tipo === 3 ? 1 : 2,
          UserSend: userAuth.IdUser
      }
      // console.log({enviarA});
      // console.log(notificacion);
      const t = await sendNotification(notificacion);
      if(t?.valid){
          toastShow(toast, 'success', 'Notificacion enviada');
          setTimeout(() => {
            limpiarCampos();
          }, 1500);
      }else{
          toastShow(toast, 'error', 'Error al enviar notificacion');
      }
    } else {
      toastShow(toast, "error", "Faltan campos por llenar");
      setShowErrors(true);
    }
  };

  // Función para limpiar campos
  const limpiarCampos = () => {
    setTitulo("");
    setContenido("");
    setAreaSelected([]);
    setTipo(0);
    setUrl("");
    setVersion("");
    setDataNotificacion("");
    setEnviarA(2);
    setUserSelected([]);
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "notificacion", config.language));
    getInfo();
}, [])

  return (
    <div className="p-3">
      <Toast position="bottom-right" ref={toast} />
      <Card
        titulo={<h3>{getLabel(baseLang, "notificacion", config.language)}</h3>}
        contenido={
          <div className="p-3">
            <Card
              titulo={<h5 className="mt-1">{getLabel(baseLang, "tipo", config.language)}</h5>}
              contenido={
                <div className="p-4 d-flex">
                  <div
                    className="field-radiobutton"
                    onClick={(e) => setTipo(0)}
                  >
                    <RadioButton name="Tipo" value={0} checked={tipo === 0} />
                    <label className="mx-2" htmlFor="city4">
                      Mensaje
                    </label>
                  </div>
                  <div
                    className="field-radiobutton"
                    onClick={(e) => setTipo(1)}
                  >
                    <RadioButton name="Tipo" value={1} checked={tipo === 1} />
                    <label className="mx-2" htmlFor="city4">
                      Actualización
                    </label>
                  </div>
                  <div
                    className="field-radiobutton"
                    onClick={(e) => setTipo(2)}
                  >
                    <RadioButton name="Tipo" value={2} checked={tipo === 2} />
                    <label className="mx-2" htmlFor="city4">
                      Link
                    </label>
                  </div>
                  <div
                    className="field-radiobutton"
                    onClick={(e) => setTipo(3)}
                  >
                    <RadioButton name="Tipo" value={3} checked={tipo === 3} />
                    <label className="mx-2" htmlFor="city4">
                      Notificación
                    </label>
                  </div>
                </div>
              }
            />

            <div style={{ marginTop: 30 }}>
              <Card
                titulo={<h5 className="mt-1">{getLabel(baseLang, "contenido", config.language)}</h5>}
                contenido={
                  <div className="mx-3">
                    {tipo !== 1 ? (
                      <div>
                        {/* TITULO */}
                        <div className="p-float-label my-4">
                          <InputText
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                            className={classNames({
                              "p-invalid": titulo === "" && showErrors,
                            })}
                            // disabled={!editable}
                            style={{ minWidth: "400px" }}
                          />
                          <label>Titulo</label>
                        </div>

                        {/* CONTENIDO */}
                        <div className="p-float-label my-4">
                          <InputTextarea
                            value={contenido}
                            onChange={(e) => setContenido(e.target.value)}
                            className={classNames({
                              "p-invalid": contenido === "" && showErrors,
                            })}
                            // disabled={!editable}
                            style={{ minWidth: "800px" }}
                          />
                          <label>Contenido</label>
                        </div>

                        {/* URL */}
                        {tipo === 2 && (
                          <div className="p-float-label my-4">
                            <InputText
                              value={Url}
                              onChange={(e) => setUrl(e.target.value)}
                              className={classNames({
                                "p-invalid": Url === "" && showErrors,
                              })}
                              // disabled={!editable}
                              style={{ minWidth: "400px", width: "100%" }}
                            />
                            <label>Url</label>
                          </div>
                        )}

                        {/* DATA NOTIFICACION */}
                        {tipo === 3 && (
                          <div className="p-float-label my-4">
                            <InputText
                              value={dataNotificacion}
                              onChange={(e) => setDataNotificacion(e.target.value)}
                              // className={classNames({
                              //   "p-invalid": Url === "" && showErrors,
                              // })}
                              // disabled={!editable}
                              style={{ minWidth: "400px", width: "100%" }}
                            />
                            <label>Notificación</label>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div>
                        {/* VERSION */}
                        <div className="p-float-label my-4">
                          <InputText
                            value={version}
                            onChange={(e) => setVersion(e.target.value)}
                            className={classNames({
                              "p-invalid": version === "" && showErrors,
                            })}
                            // disabled={!editable}
                            style={{ minWidth: "800px" }}
                          />
                          <label>Versión</label>
                        </div>
                      </div>
                    )}
                  </div>
                }
              />
            </div>

            <div style={{ marginTop: 30 }}>
              <Card
                titulo={<h5 className="mt-1">{getLabel(baseLang, "enviar", config.language)}</h5>}
                contenido={
                  <div className="py-2">
                    <div className="px-2 d-flex ">
                      <div className="px-3 d-flex">
                        <div
                          className="field-radiobutton"
                          onClick={(e) => setEnviarA(2)}
                        >
                          <RadioButton
                            name="Tipo"
                            value={1}
                            checked={enviarA === 2}
                          />
                          <label className="mx-2" htmlFor="city4">
                            Personalizado
                          </label>
                        </div>
                        <div
                          className="field-radiobutton"
                          onClick={(e) => setEnviarA(1)}
                        >
                          <RadioButton
                            name="Tipo"
                            value={1}
                            checked={enviarA === 1}
                          />
                          <label className="mx-2" htmlFor="city4">
                            Rol
                          </label>
                        </div>
                        <div
                          className="field-radiobutton"
                          onClick={(e) => setEnviarA(0)}
                        >
                          <RadioButton
                            name="Tipo"
                            value={0}
                            checked={enviarA === 0}
                          />
                          <label className="mx-2" htmlFor="city4">
                            Todos
                          </label>
                        </div>
                      </div>
                    </div>

                    {enviarA === 1 && (
                      <div className="px-4 d-flex">
                        <div className="p-float-label">
                          <MultiSelect
                            value={areaSelected}
                            options={areas}
                            onChange={(e) => setAreaSelected(e.value)}
                            optionLabel="Rol"
                            // optionValue='IdRol'
                            display="chip"
                            style={{ minWidth: "400px", width: "100%" }}
                            filter
                            filterBy="Rol"
                            className={classNames({
                              "p-invalid":
                                areaSelected.length === 0 && showErrors,
                            })}
                          />
                        </div>
                      </div>
                    )}

                    {enviarA === 2 && (
                      <div className="px-4 d-flex  align-items-center">
                        <div className="p-float-label ">
                          <MultiSelect
                            value={userSelected}
                            options={users}
                            onChange={(e) => setUserSelected(e.value)}
                            optionLabel="UserName"
                            // optionValue='idUser'
                            display="chip"
                            style={{ minWidth: "400px", maxWidth: 1000 }}
                            filter
                            filterBy="UserName"
                            className={classNames("aa", {
                              "p-invalid":
                                userSelected.length === 0 && showErrors,
                            })}
                          />
                        </div>
                        {userSelected.length > 0 && (
                          <p
                            className="ms-3  align-middle"
                            style={{ marginBottom: 0 }}
                          >
                            Seleccionados: {userSelected.length}
                          </p>
                        )}
                      </div>
                    )}
                    <div className="m-4">
                      <Button label={getLabel(baseLang, "enviarText", config.language)} onClick={enviarNoticia} />
                    </div>
                  </div>
                }
              />
            </div>
          </div>
        }
      />
    </div>
  );
}

export default NotificacionesScreen;
